import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { FirmwareUpdateStep, FirmwareUpdateStore } from '@store';

@Component({
  selector: 'app-firmware-update-modal',
  templateUrl: './firmware-update-modal.component.html',
  styleUrls: ['./firmware-update-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirmwareUpdateModalComponent {
  readonly FirmwareUpdateStep = FirmwareUpdateStep;

  constructor(
    public dialogRef: MatDialogRef<FirmwareUpdateModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      gatewaySerial: string;
    },
    public firmwareUpdateStore: FirmwareUpdateStore
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }
}
